import React, { useState, useEffect, useRef } from "react";
import { LandingPageNewsAndManuals } from "../../../../styled/common-styled";
import LangContext from "modules/shared/context/langContext";
import { Tabs, Row, Col, Empty, Spin, Tooltip, Button } from "antd";
import TabLists from "./TabLists";
import RichText from "../../../../modules/setting/NewsManuals/SlateEditor/Editor";
import { getNewsCategory, getNews, createAxios } from "../../fetch/apiclient";
import { connect } from "react-redux";
import {
  BREAKPOINTS,
  RESPONSIVE_COMPARE,
  withResponsive,
} from "../../../shared/context/ResponsiveContext";
import { ReactComponent as Alert } from "../Asset/Alert.svg";
import { ReactComponent as New } from "../Asset/new.svg";
const { TabPane } = Tabs;

const News = (props) => {
  const [list, setList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [detail, setDetail] = useState(null);
  const [isActiveId, setIsActiveId] = useState(null);
  const [loadingRichText, setLoadingRichText] = useState(false);
  const [header, setHeader] = useState({
    topic: "",
    description: "",
    cover: "",
  });
  const [bgcolor, setBgcolor] = useState(true);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const { isBreakpoint } = props;

  const isMobile = isBreakpoint(RESPONSIVE_COMPARE.DOWN, BREAKPOINTS.XS);

  useEffect(() => {
    createAxios(props.auth.accessToken);
    setLoading(true);
    getNewsCategory({}, (status, res) => {
      setCategoryList(res.data.data);
      getNews({ is_publish: true }, (status, resNews) => {
        setList(resNews.data.data);
        setLoading(false);
        if (resNews.data.data.length > 0 && !isMobile) {
          handleSelectType(resNews.data.data[0]);
        }
      });
    });
  }, []);

  const handleSelectType = (val) => {
    setDetail(null);
    setIsActiveId(val.id);
    setLoadingRichText(true);
    setTimeout(() => {
      callBackSelectedNews(val);
    }, 500);
  };

  const callBackSelectedNews = (val) => {
    let { topic, description, cover } = val;
    setDetail(JSON.parse(val.detail));
    setHeader({
      topic,
      description,
      cover,
    });
    window.scrollTo(0, 0);
    setLoadingRichText(false);
  };

  return (
    <LandingPageNewsAndManuals
      style={{ ...(isMobile && { backgroundColor: "#f0f2f5", padding: 0 }) }}
    >
      <LangContext.Consumer>
        {(i18n) =>
          isMobile ? (
            <Spin spinning={loading}>
              <div
                style={{
                  width: "100%",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "200%", // 100% สำหรับ list + 100% สำหรับ detail
                    transition: "transform 0.2s ease-in-out",
                    transform:
                      header.topic !== ""
                        ? "translateX(-50%)"
                        : "translateX(0%)",
                    height: "fit-content",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                      gap: "8px",
                      height: header.topic === "" ? "auto" : "0px",
                    }}
                  >
                    {list.map((item) => (
                      <div
                        style={{
                          backgroundColor: "#FFF",
                          borderRadius: "8px",
                          padding: "8px",
                          boxShadow: "0 1px 2px 0 rgba(145 158 171 / 0.16)",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSelectType(item)}
                      >
                        <img
                          src={item.cover}
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                        <div style={{ padding: "16px 8px" }}>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <p
                              style={{
                                fontSize: "16px",
                                fontWeight: 700,
                                marginBottom: "4px",
                              }}
                            >
                              {item.topic}
                            </p>
                            <p
                              style={{
                                fontSize: "14px",
                                fontWeight: 500,
                                color: "#637381",
                                marginBottom: "4px",
                              }}
                            >
                              {item.description}
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "8px",
                            }}
                          >
                            {!!item.is_important && (
                              <Tooltip title="ข่าวสำคัญ">
                                <Alert />
                              </Tooltip>
                            )}

                            {!!item.is_new && (
                              <Tooltip title="ข่าวใหม่">
                                <New />
                              </Tooltip>
                            )}
                            {/* <NewBadge /> */}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div
                    style={{
                      height: "inherit", // ปรับความสูงตามเนื้อหา
                      overflowY: "auto",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "16px",
                      marginTop: "8px",
                      width: "100%",
                    }}
                  >
                    <div style={{ display: "flex", marginTop: "8px" }}>
                      <Button
                        type="link"
                        icon="left"
                        onClick={() => {
                          setHeader({ topic: "", description: "", cover: "" });
                          setDetail(null);
                        }}
                      >
                        {i18n.b.back}
                      </Button>
                    </div>
                    <div style={{ padding: "12px 12px 0px 12px" }}>
                      <h1 style={{ fontSize: 24, margin: 0, fontWeight: 700 }}>
                        {header.topic}
                      </h1>
                      <p style={{ fontSize: 16, marginBottom: 8 }}>
                        {header.description}
                      </p>
                      <img
                        src={header.cover}
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: 16,
                        }}
                      />
                    </div>
                    <Row>
                      <Col span={24}>
                        {detail ? (
                          <RichText
                            description={detail}
                            disabled={true}
                            setDescription={(val) => {}}
                          />
                        ) : (
                          <Empty
                            style={{ paddingTop: window.innerHeight - 700 }}
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Spin>
          ) : (
            <Row>
              <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                <Spin spinning={loading} style={{ marginTop: 200 }}>
                  <Tabs
                    defaultActiveKey="0"
                    className="TabsStylingHomeDashboard"
                  >
                    <TabPane tab={i18n.a.all} key="0">
                      <TabLists
                        list={list}
                        handleSelectType={handleSelectType}
                        isActiveId={isActiveId}
                      />
                    </TabPane>
                    {categoryList.map((item) => (
                      <TabPane
                        tab={i18n.newsManuals[`${item.name}`]}
                        key={item.id}
                      >
                        <TabLists
                          list={list.filter(
                            (listVal) => listVal.news_category_id == item.id
                          )}
                          handleSelectType={handleSelectType}
                          isActiveId={isActiveId}
                        />
                      </TabPane>
                    ))}
                  </Tabs>
                </Spin>
              </Col>
              <Col xs={24} sm={16} md={16} lg={16} xl={16}>
                <Spin spinning={loadingRichText}>
                  <div
                    style={{
                      borderLeft: "1px solid rgb(232 232 232)",
                      minHeight: window.innerHeight - 200,
                      height: "auto", // ปรับความสูงตามเนื้อหา
                      overflowY: "auto",
                    }}
                  >
                    <div style={{ padding: "24px 24px 0px 24px" }}>
                      <h1 style={{ fontSize: 24, margin: 0, fontWeight: 700 }}>
                        {header.topic}
                      </h1>
                      <p style={{ fontSize: 16, marginBottom: 8 }}>
                        {header.description}
                      </p>
                      <img
                        src={header.cover}
                        style={{
                          width: "100%",
                          height: "auto",
                          borderRadius: 16,
                        }}
                      />
                    </div>
                    <Row>
                      <Col span={24}>
                        {detail ? (
                          <RichText
                            description={detail}
                            disabled={true}
                            setDescription={(val) => {}}
                          />
                        ) : (
                          <Empty
                            style={{ paddingTop: window.innerHeight - 700 }}
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                </Spin>
              </Col>
            </Row>
          )
        }
      </LangContext.Consumer>
    </LandingPageNewsAndManuals>
  );
};
export default connect(({ auth }) => ({ auth }), {})(withResponsive(News));

const NewBadge = () => {
  const keyframes = `
    @keyframes backgroundCycle {
      0%   { background-color: #FF3333; }
      25%  { background-color: #FFFF00; }
      50%  { background-color: #FF3333; }
      75%  { background-color: #FFFF00; }
      100% { background-color: #FF3333; }
    }
  `;

  return (
    <>
      {/* Inject keyframes into the document */}
      <style>{keyframes}</style>

      {/* Apply animation with inline styles */}
      <div
        style={{
          animation: "backgroundCycle 1s step-start infinite",
          transition: "background-color 1s",
        }}
      >
        <span
          style={{
            textAlign: "center",
            padding: "4px",
            fontSize: "8px",
            color: "#000",
          }}
        >
          NEW
        </span>
      </div>
    </>
  );
};
